<template>
  <page-widget v-loading="$mip('getActivatedServices')">
    <template v-slot:heading>Подключенные услуги</template>
    <template v-slot:body>
      <el-table
        :data="services"
        empty-text="Нет подключенных услуг"
        style="width: 100%">
        <el-table-column
          prop="service"
          label="Услуга">
        </el-table-column>
        <el-table-column
          label="Окончание действия"
          width="180">
          <template v-slot="scope">
            {{ formatDate(scope.row.expireDate) }}
          </template>
        </el-table-column>
      </el-table>
    </template>
  </page-widget>
</template>

<script>
  import PageWidget from '@/components/PageWidget'
  import { formatDate } from '@/utils'

  export default {
    components: {
      PageWidget
    },

    data() {
      return {
        services: []
      }
    },

    async created() {
      this.services = (await this.$http.getActivatedServices()).data
    },

    methods: {
      formatDate
    }
  }
</script>